import { EnvironmentProviders, Provider } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { reportsStoreFeatureName } from './consts';
import { ReportsMetricsEffects } from './metrics/metrics.effects';
import { ReportsMetricsHttpClient } from './metrics/metrics.http-client';
import { ReportsMetricsNamespace, ReportsMetricsReducer } from './metrics/metrics.store';

const reportsState = provideState(reportsStoreFeatureName, {
  [ReportsMetricsNamespace]: ReportsMetricsReducer,
});

const reportsEffects = provideEffects([ReportsMetricsEffects]);

export const coreReportsProviders: Array<EnvironmentProviders | Provider> = [
  ReportsMetricsHttpClient,
  reportsState,
  reportsEffects,
];
